var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudIdentity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2287E0;}\r\n\t.st1{fill:#18A2E6;}\r\n\t.st2{fill:#12A0E5;}\r\n\t.st3{fill:#2E91E6;}\r\n\t.st4{fill:#F4F4F4;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.5,28.8c0,1.7,0,3.3,0,5c0,3.2,0.1,6.4,0,9.5c-0.2,6.8-2.5,12.8-6.9,18.1c-3.5,4.2-7.9,7.1-13.2,8.5 c-0.3,0.1-0.6,0.1-0.9,0c-6.4-1.8-11.3-5.6-15-11c0-0.1-0.1-0.1-0.1-0.2c0.3,0,0.3,0.2,0.5,0.4c1.4,2.1,3.1,3.9,5,5.5 c2.8,2.4,6,4.1,9.6,5c0.3,0.1,0.4,0,0.4-0.3c0-0.9,0-1.8,0-2.8c0-1.2,0-1.1-1.2-1.4c-1.1-0.2-2.2-0.6-3-1.5 c-0.4-0.5-0.9-0.9-1.4-1.4c-0.3-0.3-0.8-0.6-1-1c0.2,0,0.3,0.1,0.4,0.2c1.7,1.1,3.4,2,5.3,2.7c0.6,0.2,1.1,0.3,1.7,0 c0.6-0.3,1.2-0.5,1.8-0.7c2.9-1.3,5.4-3,7.4-5.5c0.2-0.2,0.2-0.4,0.2-0.7c0-1.5,0-3.1,0-4.6c0-0.4,0-0.9-0.1-1.3 c-0.3-1.3-1-2.3-2-3.1C70.8,46.1,68,45.2,65,45c0.1-0.4-0.1-0.7-0.4-1c-1.4-1.3-2.7-2.8-4.3-4c-0.2-0.2-0.5-0.4-0.4-0.7 c0.1,0.1,0.2,0.2,0.3,0.3c3,2.9,7.9,2.5,10.3-0.9c1.7-2.4,1.7-5,0.3-7.6c0.3,0,0.4,0.2,0.5,0.3c0.9,0.9,1.8,1.8,2.6,2.6 c0.1,0.1,0.2,0.3,0.3,0.2c0.2-0.1,0.1-0.2,0.2-0.4c0.2-0.9,0.2-1.9,0.3-2.8c0.2-1.5,0.1-3-0.1-4.5c-0.1-0.6-0.2-1.2-0.2-1.8 c-0.1-0.4,0.1-0.4,0.4-0.3c0.9,0.4,1.7,0.7,2.6,1.1C80.2,26.6,82.8,27.7,85.5,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.5,42.5c0-3.7,0-7.5,0-11.2c0-1.1,0-2.1,0-3.2c0.3,0,0.6-0.2,1-0.3c3.6-1.4,7.2-2.8,10.8-4.2 c2.7-1.1,5.5-2.1,8.2-3.2c0.4-0.1,0.5-0.1,0.5,0.3c0,2.4,0,4.8,0,7.1c-0.3,0-0.6,0-0.9,0.1c-1.5,0.2-2.8,0.9-3.9,1.9 c-0.3,0-0.6,0.2-0.7,0.4c-0.6,0.7-1.2,1.4-1.6,2.2c-1,2.2-1.1,4.4-0.3,6.7c0.1,0.3,0.1,0.6-0.2,0.8c-0.7,0.5-0.7,0.6-0.2,1.4 c0.2,0.4,0.2,0.6-0.2,0.8c-0.3,0.1-0.5,0.3-0.8,0.4c-2,1.1-4.1,1.4-6.3,1.5c-0.8,0-1.6,0-2.4-0.2C46.4,43.4,45.2,43.5,44.5,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.5,42.5c0.7,0.9,1.8,0.9,2.8,1.2c0.8,0.2,1.6,0.2,2.4,0.2c2.2-0.1,4.4-0.4,6.3-1.5c0.3-0.1,0.5-0.3,0.8-0.4 c0.4-0.2,0.4-0.4,0.2-0.8c-0.5-0.7-0.4-0.9,0.2-1.4c0.3-0.2,0.3-0.4,0.2-0.8c-0.8-2.3-0.7-4.5,0.3-6.7c0.4-0.8,1-1.5,1.6-2.2 c0.2-0.2,0.4-0.4,0.7-0.4c-0.5,0.6-1,1.1-1.3,1.7c-1,1.9-1,3.9-0.2,5.9c0,0.1,0,0.2,0.1,0.2l0,0c0,0.1,0,0.2,0.1,0.2l0,0 c0,0.1,0,0.2,0.1,0.2l0,0c0,0.2,0,0.4,0.2,0.4l0,0c-0.1,0.2,0,0.3,0.2,0.3l0,0c-0.1,0.3,0.1,0.3,0.3,0.3c0,0,0.1,0.1,0.1,0.1 c-0.1,0.4,0.2,0.6,0.4,0.7c1.6,1.1,2.9,2.6,4.3,4c0.3,0.3,0.5,0.6,0.4,1c-1.9,0.1-3.6,0.6-5.3,1.3c-1.6,0.7-3.1,1.6-4.1,3.1 c-0.5,0.7-0.8,1.5-0.8,2.4c0,2,0,3.9,0,5.9c0,0.3,0.1,0.5,0.4,0.5l0,0c0,0.4,0.3,0.6,0.6,0.7l0,0c0,0.2,0,0.3,0.1,0.4 c0.5,0.5,1,1,1.5,1.4c0.1,0.1,0.2,0.1,0.4,0.1c0,0,0.1,0.1,0.1,0.1c0,0.3,0.2,0.4,0.4,0.3l0,0c0.2,0.5,0.7,0.7,1,1 c0.5,0.5,1,0.9,1.4,1.4c0.8,1,1.9,1.3,3,1.5c1.2,0.3,1.2,0.2,1.2,1.4c0,0.9,0,1.8,0,2.8c0,0.4-0.1,0.4-0.4,0.3 c-3.6-0.9-6.8-2.7-9.6-5c-1.9-1.6-3.6-3.4-5-5.5c-0.1-0.2-0.2-0.4-0.5-0.4c0,0,0,0,0,0c0.1-0.2,0.1-0.3-0.2-0.3c0,0,0,0,0,0 c0.1-0.2,0-0.2-0.2-0.2c0,0,0,0,0,0c0-0.3,0-0.6-0.4-0.6c0,0,0,0,0,0c0.1-0.3,0-0.5-0.3-0.5c0,0,0,0,0,0c0-0.3,0-0.6-0.4-0.7 c0,0,0,0,0,0c0-0.1,0.1-0.2-0.1-0.2c0,0,0,0,0,0c0.1-0.2,0-0.3-0.2-0.3c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2c0,0,0,0,0,0 c0-0.1,0-0.2-0.1-0.2c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2c0,0,0,0,0,0c0-0.1,0.1-0.3-0.1-0.3 c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2c0,0,0,0,0,0c0.1-0.2,0-0.4-0.2-0.4c0,0,0,0,0,0c0-0.1,0-0.3-0.1-0.3c0,0,0,0,0,0 c0-0.1,0-0.2-0.1-0.2c0,0,0,0,0,0c0-0.1,0.1-0.3-0.1-0.3c0,0,0,0,0,0c0.1-0.2,0-0.4-0.2-0.5c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2 c0,0,0,0,0,0c0-0.1,0-0.3-0.1-0.3c0,0,0,0,0,0c0-0.1,0-0.3-0.1-0.3c0,0,0,0,0,0c0-0.1,0-0.3-0.1-0.3c0,0,0,0,0,0 c0-0.1,0-0.3-0.1-0.3c0,0,0,0,0,0c0-0.2,0.1-0.3-0.1-0.4c0,0,0,0,0,0c0-0.1,0-0.3-0.1-0.3c0,0,0,0,0,0c0-0.2,0.1-0.3-0.1-0.4 c-0.5-1.8-0.8-3.6-0.9-5.5c0,0,0,0,0,0c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0,0,0,0,0-0.1C44.5,43.5,44.5,43,44.5,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65,27.9c0-2.4,0-4.8,0-7.1c0-0.5-0.1-0.5-0.5-0.3c-2.7,1.1-5.5,2.1-8.2,3.2c-3.6,1.4-7.2,2.8-10.8,4.2 c-0.3,0.1-0.6,0.3-1,0.3c-0.1-0.4,0.3-0.3,0.4-0.4c4.4-1.7,8.8-3.4,13.2-5.1c2.1-0.8,4.3-1.7,6.4-2.5c0.2-0.1,0.4-0.1,0.7,0 c6.6,2.7,13.1,5.5,19.7,8.2c0.2,0.1,0.5,0.1,0.4,0.5c-2.6-1.1-5.3-2.2-7.9-3.3c-0.9-0.4-1.7-0.7-2.6-1.1c-0.3-0.1-0.5-0.1-0.4,0.3 c0.1,0.6,0.2,1.2,0.2,1.8c0.2,1.5,0.3,3,0.1,4.5c-0.1,0.9-0.2,1.9-0.3,2.8c0,0.1,0,0.3-0.2,0.4c-0.2,0.1-0.2-0.1-0.3-0.2 c-0.9-0.9-1.8-1.8-2.6-2.6c-0.1-0.1-0.3-0.3-0.5-0.3C69.4,29.1,67.5,28,65,27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48,56.4c0.4,0.1,0.4,0.4,0.4,0.7C48.2,56.9,48.1,56.6,48,56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.7,57.6c0.4,0,0.3,0.3,0.4,0.6C48.9,58.1,48.8,57.9,48.7,57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.4,57.1c0.3,0,0.4,0.2,0.3,0.5C48.5,57.5,48.5,57.3,48.4,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.3,52.6c0.2,0.1,0.3,0.3,0.2,0.5C46.4,53,46.3,52.8,46.3,52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.8,54c0.2,0.1,0.3,0.2,0.2,0.4C46.9,54.3,46.8,54.1,46.8,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.2,58.5c0.3,0,0.3,0.1,0.2,0.3C49.3,58.7,49.3,58.6,49.2,58.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.4,49.9c0.2,0.1,0.1,0.3,0.1,0.4C45.4,50.2,45.5,50,45.4,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.6,50.7c0.2,0.1,0.1,0.3,0.1,0.4C45.6,51,45.7,50.8,45.6,50.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.1,58.2c0.2,0,0.3,0.1,0.2,0.2C49.1,58.4,49.1,58.3,49.1,58.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.7,55.8c0.2,0.1,0.3,0.1,0.2,0.3C47.8,56,47.7,55.9,47.7,55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.5,53.1c0.2,0,0.1,0.2,0.1,0.3C46.5,53.4,46.5,53.2,46.5,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.7,53.6c0.2,0,0.1,0.2,0.1,0.3C46.7,53.9,46.7,53.8,46.7,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.1,54.6c0.2,0,0.1,0.2,0.1,0.3C47.2,54.9,47.2,54.7,47.1,54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.1,52c0.2,0.1,0.1,0.2,0.1,0.3C46.1,52.3,46.1,52.1,46.1,52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46,51.7c0.1,0.1,0.1,0.2,0.1,0.3C45.9,52,46,51.8,46,51.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.9,51.4c0.1,0.1,0.1,0.2,0.1,0.3C45.8,51.6,45.9,51.5,45.9,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.8,51.1c0.1,0.1,0.1,0.2,0.1,0.3C45.7,51.3,45.8,51.2,45.8,51.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.6,50.3c0.2,0.1,0.1,0.2,0.1,0.3C45.5,50.6,45.6,50.4,45.6,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.6,53.4c0.1,0,0.1,0.1,0.1,0.2C46.6,53.6,46.6,53.5,46.6,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.2,52.4c0.1,0,0.1,0.1,0.1,0.2C46.2,52.5,46.2,52.4,46.2,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47,54.4c0.1,0,0.1,0.1,0.1,0.2C47.1,54.5,47.1,54.5,47,54.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.3,54.9c0.1,0,0.1,0.1,0.1,0.2C47.3,55.1,47.3,55,47.3,54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.4,55.1c0.1,0,0.1,0.1,0.1,0.2C47.4,55.3,47.4,55.2,47.4,55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.5,55.3c0.1,0,0.1,0.1,0.1,0.2C47.5,55.5,47.5,55.4,47.5,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6,55.6c0.1,0,0.1,0.1,0.1,0.2C47.6,55.7,47.6,55.6,47.6,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.9,56.1c0.2,0,0.2,0.1,0.1,0.2C47.9,56.3,47.9,56.2,47.9,56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.5,44C44.5,44.1,44.6,44.1,44.5,44c0,0.1,0,0.1,0,0.1C44.5,44.1,44.5,44.1,44.5,44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.5,44.4C44.6,44.4,44.6,44.4,44.5,44.4C44.6,44.4,44.6,44.4,44.5,44.4C44.5,44.4,44.5,44.4,44.5,44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M58,60.9C57.9,60.8,57.9,60.8,58,60.9c-0.7-0.8-1.5-1.4-2.1-2c0,0,0,0,0,0c-0.2-0.3-0.4-0.5-0.6-0.7 c0,0,0,0,0,0c-0.1-0.2-0.2-0.4-0.4-0.5c0-2,0-3.9,0-5.9c0-0.9,0.3-1.7,0.8-2.4c1-1.5,2.5-2.4,4.1-3.1c1.7-0.7,3.4-1.2,5.3-1.3 c3,0.2,5.8,1.2,8.2,3.1c1,0.8,1.8,1.8,2,3.1c0.1,0.4,0.1,0.9,0.1,1.3c0,1.5,0,3.1,0,4.6c0,0.3-0.1,0.5-0.2,0.7 c-2,2.5-4.5,4.2-7.4,5.5c-0.6,0.3-1.2,0.4-1.8,0.7c-0.6,0.3-1.1,0.2-1.7,0c-1.9-0.7-3.7-1.6-5.3-2.7c-0.1-0.1-0.2-0.2-0.4-0.2 c0,0,0,0,0,0C58.3,61,58.2,60.9,58,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65,27.9c2.5,0.1,4.4,1.2,5.8,3.2c1.4,2.6,1.4,5.1-0.3,7.6c-2.4,3.4-7.3,3.9-10.3,0.9 c-0.1-0.1-0.2-0.2-0.3-0.3c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.1-0.3-0.3-0.3c0,0,0,0,0,0c0-0.1-0.1-0.2-0.2-0.3c0,0,0,0,0,0 c0-0.2-0.1-0.3-0.2-0.4c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2c0,0,0,0,0,0c0-0.1,0-0.2-0.1-0.2 c-0.8-2-0.8-4,0.2-5.9c0.3-0.7,0.8-1.2,1.3-1.7c1.1-1,2.4-1.7,3.9-1.9C64.4,27.9,64.7,27.9,65,27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.8,58.8c0.7,0.7,1.4,1.2,2,1.9c-0.1,0-0.3,0-0.4-0.1c-0.5-0.5-1-1-1.5-1.4C55.8,59.2,55.8,59,55.8,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.2,58.1c0.3,0.2,0.5,0.5,0.6,0.7C55.4,58.7,55.2,58.5,55.2,58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.8,57.6c0.2,0.2,0.3,0.3,0.4,0.5C54.8,58.1,54.7,57.9,54.8,57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58,60.9c0.2,0,0.3,0.2,0.4,0.3C58.1,61.2,57.9,61.2,58,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.5,38.9c0.2,0.1,0.2,0.2,0.3,0.3C59.6,39.2,59.4,39.1,59.5,38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59,38.1c0.1,0.1,0.2,0.2,0.2,0.4C59,38.5,59,38.3,59,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.3,38.6c0.1,0.1,0.2,0.2,0.2,0.3C59.3,38.9,59.2,38.7,59.3,38.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.7,37.5c0.1,0.1,0.1,0.1,0.1,0.2C58.7,37.7,58.7,37.6,58.7,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.8,37.7c0.1,0,0.1,0.1,0.1,0.2C58.8,37.9,58.8,37.8,58.8,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.9,37.9c0.1,0,0.1,0.1,0.1,0.2C58.9,38.1,58.9,38,58.9,37.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIdentity);
export default __webpack_public_path__ + "static/media/CloudIdentity.2b76281a073840b2fb29bc7806d7ab86.svg";
export { ForwardRef as ReactComponent };